import React from "react";

const ProgressBar = ({title, rating}) => {
    return <div className="sl-display-flex sl-flex-col">
        <div className="sl-display-flex sl-flex-row sl-justify-space-between sl-mb-1">
            <span className="sl-f sl-text-sm">{title}</span>
            <span className="sl-f sl-text-sm">{rating}</span>
        </div>
        <div className="sl-bg-gray-200 sl-width-100 sl-h-2 sl-border-radius-8">
            <div className="sl-bg-gray-600  sl-h-2 sl-border-radius-8"
                 style={{width: `${rating}0%`}}></div>
        </div>
    </div>
}

export default ProgressBar;